import Api from '../api.js'
import bus from '~/bus.js'
const state = {
  endpoint: '',
  emptyValue: {},
  record: {},
  lastId: 0
}

const getters = {}

const mutations = {
  delete (state) {
    state.record = Object.assign({}, state.emptyValue)
  },
  edit (state, record) {
    const originalRecord = state.record || {}
    state.record = { ...originalRecord, ...record }
  },
  load (state, record) {
    state.record = record
  }
}

const actions = {
  clear ({commit}) {
    commit('delete')
  },
  reload ({state, commit, dispatch}) {
    commit('delete')
    return new Promise((resolve, reject) => {
      dispatch('load', state.lastId).then(response => {
        resolve(response)
      }, response => {
        reject(response)
      })
    })
  },
  load ({commit, state}, id) {
    return new Promise((resolve, reject) => {
      Api.get(state.endpoint + '/' + id, {}, response => {
        commit('load', response.body)
        state.lastId = id
        bus.$emit(state.endpoint + '/loadedElements', response.body)
        resolve(response)
      }, response => {
        reject(response)
      })
    })
  },
  loadAsGuest ({commit, state}, {id, auth}) {
    return new Promise((resolve, reject) => {
      Api.get(state.endpoint + '/' + id, {}, response => {
        commit('load', response.body)
        state.lastId = id
        bus.$emit(state.endpoint + '/loadedElements', response.body)
        resolve(response)
      }, response => {
        reject(response)
      }, false, {Authorization: auth})
    })
  },
  edit ({commit, state}, {id, params}) {
    return new Promise((resolve, reject) => {
      Api.put(state.endpoint + '/' + id, params, response => {
        commit('edit', params)
        resolve(response)
      }, response => {
        reject(response)
      })
    })
  },
  create ({state, dispatch}, params) {
    return new Promise((resolve, reject) => {
      Api.post(state.endpoint, params, response => {
        // dispatch('load', response.body)
        resolve(response)
      }, response => {
        reject(response)
      })
    })
  },
  delete ({commit, state}, id) {
    return new Promise((resolve, reject) => {
      Api.delete(state.endpoint + '/' + id, {}, response => {
        commit('delete')
        resolve(response)
      }, response => {
        reject(response)
      })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/common/item.js